<mbsc-popup
  [options]="popupOptions"
  [anchor]="popupAnchorBacklogFilter"
  [buttons]="popupButtonsBacklogFilter"
  #backlogFilterPopup
>

  <div class="mbsc-form-group">
    <div class="mbsc-form-group-title">Titel</div>
    <mbsc-input
      [(ngModel)]="searchTitle"
      placeholder="Titel suchen"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-input>

    <div class="mbsc-form-group-title">Ort</div>
    <mbsc-input
      [(ngModel)]="searchLocation"
      placeholder="Ort suchen"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-input>

    <div class="mbsc-form-group-title">Status</div>
    <mbsc-select
      [data]="statusData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Status"
      label="Status"
      [(ngModel)]="searchStatus"
      [selectMultiple]="true"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Kategorie</div>
    <mbsc-select
      [data]="categoryData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Kategorie"
      label="Kategorie"
      [(ngModel)]="searchCategory"
      [selectMultiple]="true"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Einsatzzeit</div>
    <mbsc-select
      [data]="operatingTimeData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Einsatzzeit"
      label="Einsatzzeit"
      [(ngModel)]="searchOperatingTime"
      [selectMultiple]="true"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Termin Typ</div>
    <mbsc-select
      [data]="taskType"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Termin Typ"
      label="Termin Typ"
      [(ngModel)]="searchTaskType"
      [selectMultiple]="true"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Online Termin</div>
    <mbsc-switch
      label="Online Termin"
      [(ngModel)]="searchOnline"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-switch>

    <div class="mbsc-form-group-title">Startzeit</div>
    <mbsc-datepicker
      [controls]="['time']"
      [(ngModel)]="searchStartTime"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-datepicker>

    <div class="mbsc-form-group-title">Endzeit</div>
    <mbsc-datepicker
      [controls]="['time']"
      [(ngModel)]="searchEndTime"
      (ngModelChange)="applyBacklogFilter()"
    ></mbsc-datepicker>

    <div class="mbsc-form-group-title">maximale Terminlänge</div>
    <div class="duration-slider-container">
      <ngx-slider
        [(value)]="minDuration"
        [(highValue)]="maxDuration"
        [options]="sliderOptions"
        (userChangeEnd)="applyBacklogFilter()"
      ></ngx-slider>
    </div>
  </div>
</mbsc-popup>
